import { RESPONSIVENESS_MANAGER_TRIGGER } from './actions.type';
import { RESPONSIVENESS_WIDTH_SET } from './mutations.type';

const initialState = {
  windowWidth: window.innerWidth,
  mobileBreakpoint: 992
};

export const state = Object.assign({}, initialState);

export const actions = {
  [RESPONSIVENESS_MANAGER_TRIGGER](context) {
    window.addEventListener('resize', e => {
      let windowWidth = e.target.innerWidth;

      context.commit(RESPONSIVENESS_WIDTH_SET, windowWidth);
    });
  },
};

export const mutations = {
  [RESPONSIVENESS_WIDTH_SET]: (state, windowWidth) => state.windowWidth = windowWidth
};

const getters = {
  windowWidth: state => state.windowWidth,
  isMobileWidth: state => state.windowWidth < state.mobileBreakpoint
};

export default {
  state,
  actions,
  mutations,
  getters
};
